import { useState } from "react";
import { post } from "../networking/RequestService";
import { toast } from "react-toastify";
import { apiErrorText } from "app/popleads/networking/apiErrorText";

const useInviteUser = () => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const inviteUser = async (params) => {
        setLoading(true);
        setError(null);

        try {
            const payload = {
                fn: "inviteUser",
                email: params.email,
                name: params.name,
                surname: params.surname,
                managername: params.managerName,
            };

            const response = await post(payload);
            if (response && response.data) {
                toast.success("User invited successfully");
                return { data: response.data };
            }
        } catch (error) {
            const errorMessage = apiErrorText(error);
            toast.error(errorMessage);
            setError(errorMessage);
            return { error: errorMessage };
        } finally {
            setLoading(false);
        }
    };

    return { loading, error, inviteUser };
};

export default useInviteUser;
